import React, { useState, memo } from "react";
import {
	Button,
	Progress
} from "reactstrap";
import Sound from 'react-sound';
import MicRecorder from 'mic-recorder-to-mp3';
import Microphone from "../../../assets/images/MicrophoneCheck.png";

const Mp3Recorder = new MicRecorder({ bitRate: 128 });

const MicrophoneCheck = memo( function MicrophoneCheck({ setNextFlag }) {
	const [recordPer, setRecordPer] = useState(0);
	const [isRecording, setIsRecording] = useState(false);
	const [blobURL, setBlobURL] = useState('');
	const [btnText, setBtnText] = useState('Playback');

	const startRecording = () => {
		Mp3Recorder
		.start()
		.then(() => {
			setIsRecording(true);
			setBlobURL('');
		});
	};

	const stopRecording = () => {
		Mp3Recorder
		.stop()
		.getMp3()
		.then(([buffer, blob]) => {
			const blobURL = URL.createObjectURL(blob);

			setIsRecording(false);
			setBlobURL(blobURL);
		});
	};

	const playRecording = () => {
		if (btnText === "Playback") {
			setBtnText("Stop Playback");
		} else {
			setBtnText("Playback");
			setNextFlag(true);
		}
	};

	const handleRecordPlaying = (obj) => {
		setRecordPer(obj.position*100/obj.duration);
	}

	return (
		<div className="col-xs-12 successContent">
			<div className="row w-100">
				<div className="col-sm-8">
					<h4 className="mt-0">Microphone Check</h4>
					<h6>This is an opportunity to check that your microphone is working correctly</h6>
                     <h6>Speaking works best with a proper headset and quiet environment.</h6>
					<ol>
						<li>Make sure your headset is on and the microphone is in the downward position near your mouth.</li>
						<li>When you are ready, click on the Record button and say "Testing, testing, one, two, three" into the microphone</li>
						<li>After you have spoken, cilck on the Stop button. Your recording is now complete</li>
						<li>Now click on the Playback button. You should clearly hear yourself speaking</li>
						<li>If you can not hear your voice clearly. please raise your hand to get the atteration of the Test Administrator</li>
					</ol>

					<div className="currentStatus">
						<p>Status: Click record to begin</p>
						<Progress color="info" value={recordPer} />
						
						<div className='stop-btn'>
							<Button
								color="success"
								disabled={isRecording}
								className="p-5px"
								onClick={startRecording}
								size="xs"
							>Record</Button>
							
							<Button
								color="success"
								onClick={playRecording}
								className="p-5px"
								size="xs"
							>{btnText}</Button>
							
							<Button
								color="success"
								disabled={!isRecording}
								onClick={stopRecording}
								className="p-5px"
								size="xs"
							>Stop</Button>
						</div>
					</div>
				</div>
				<div className="col-sm-4">
                    <div className="testingImgOuter">
                      <img
                        src={Microphone}
                        alt="headset"
                      />
                    </div>
                </div>
			</div>

			<Sound
				autoLoad={true}
				url={blobURL}
				playStatus={btnText === "Stop Playback" ? Sound.status.PLAYING : Sound.status.STOPPED}
				onPlaying={handleRecordPlaying}
				onFinishedPlaying={playRecording}
			/>
		</div>
	);
});

export default MicrophoneCheck;